<!--
 * @Description: 编辑活码页面
 * @Author: mdb
 * @Date: 2023-04-17 16:10:58
 * @LastEditTime: 2023-04-19 16:34:57
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm type="edit" title="编辑活码" paramCode="zbu_source_channel_lbu" subdomain="lbu" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from '@/views/marketing/marketingManage/activityCode/components/DetailForm.vue'
</script>
<script lang="ts">
export default { name: 'DcCosLbuActivityCodeEdit' }
</script>

<style scoped></style>
